import React, { useState, useEffect } from 'react'
//import RosterAndScheduleHomeNavigation from './RosterAndScheduleHomeNavigation'
import PlayerHistoryHomeNavigation from './PlayerHistoryHomeNavigation'
import './StatsAndStandingsHome.css'
import Footer from '../UIElements/Footer'
import Banner from './Banner'
import SearchForPlayer from '../UIElements/SearchForPlayer'

const PlayerStatsHome = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return (
		<div className='page-wrapper' style={{ overflowX: 'hidden' }}>
			<PlayerHistoryHomeNavigation />

			{!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)}

			<main className='page-content'>
				<div style={{ marginTop: '1rem', marginBottom: '16rem' }}>
					<div className='playerstatsnote'>
						<h4>To find a player's page, start typing their last name:</h4>
					</div>
					<SearchForPlayer />
				</div>
			</main>

			<Footer />
		</div>
	)
}

/* const PlayerStatsHome = () => {
	return (
		<div>
			<PlayerHistoryHomeNavigation />
			<div style={{ marginTop: '6rem' }}>
				<div className='playerstatsnote'>
					<h4>To find a player's page, start typing their last name:</h4>
				</div>
				<SearchForPlayer />
			</div>
		</div>
	)
} */

export default PlayerStatsHome
